import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Global } from "../../utils/Global";

export const Escalafon = ({ updateValue, nuevoValue, disabled }) => {
  const [escalafon, setEscalafon] = useState({
    label: Global().escalafon[0],
    value: Global().escalafon[0],
  });

  useEffect(() => {
    if (
      nuevoValue != null &&
      nuevoValue != "" &&
      nuevoValue.value != escalafon.value
    ) {
      setEscalafon({ value: nuevoValue, label: nuevoValue });
      updateValue("escalafon", nuevoValue);
    }
  }, [nuevoValue]);

  return (
    <Select
      isDisabled={disabled}
      value={escalafon}
      name="escalafon"
      onChange={(choice) => {
        console.log("ESCALAFON ", choice);
        updateValue("escalafon", choice.value);
        setEscalafon(choice);
      }}
      placeholder="Seleccione"
      options={Global().escalafon.map((c) => {
        return { value: c, label: c=="" ? '-Seleccione opción-': c };
      })}
    />
  );
};
